import { render, staticRenderFns } from "./AskWrapper.vue?vue&type=template&id=1f5615ee&scoped=true&"
import script from "./AskWrapper.vue?vue&type=script&lang=js&"
export * from "./AskWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AskWrapper.vue?vue&type=style&index=0&id=1f5615ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5615ee",
  null
  
)

export default component.exports